import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const favoriteAction = createAsyncThunk(
    'add-favorite',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/users/api/add-favorite`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const favoriteSlice = createSlice({
    name: 'add-favorite',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(favoriteAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(favoriteAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(favoriteAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const favoriteReducer = favoriteSlice.reducer